import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseService } from '../../services/firebase.service';
import { SnackBarService } from '../../services/snack-bar.service';

import { ModalComponent }  from '../modal/modal';

import { Feedback } from '../../models/feedback';

@Component({
  selector    : 'feedback-modal',
  templateUrl : 'feedback-modal.html',
  styleUrls   : [ 'feedback-modal.scss' ]
})

export class FeedbackModalComponent {
  @Input() email : string;
  @Input() name  : string;
  @Input() uid   : string;

  @ViewChild(ModalComponent)
  private modalPassthrough : ModalComponent;

  type    : string;
  subject : string;
  message : string;

  constructor(
    private firebaseService : FirebaseService,
    private snackBarService : SnackBarService,
    private route           : Router
  ) {}

  public show() : void {
    this.modalPassthrough.show();
  }

  public hide() : void {
    this.modalPassthrough.hide();

    this.type = this.subject = this.message = null;
  }

  send() : void {
    const feedback : Feedback = {
      createdAt   : null,
      lastUpdated : null,
      responded   : null,
      resolved    : null,
      uid         : this.uid || null,
      url         : this.route.url,
      name        : this.name,
      email       : this.email,
      type        : this.type,
      subject     : this.subject,
      message     : this.message
    };

    this.firebaseService.feedback.create(feedback)
      .then(() => {
        this.snackBarService.show({
          message : 'Your feedback was sent'
        });

        this.hide();
      });
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/feedback-modal/feedback-modal.ts